<template>
  <div
    v-if="typeof(controller.condition) !== 'undefined'"
    @mouseover="onHover"
    @mouseleave="onLeave"
  >
    <b-form-input
      v-model="inputValue"
      :state="controller.condition(inputValue)"
      aria-describedby="input-live-help input-live-feedback"
      :placeholder="controller.placeholder"
      trim
      :size="sizeinput"
      :class="classname"
    />
    <b-form-invalid-feedback class="input-live-feedback">
      {{ controller.feedback }}
    </b-form-invalid-feedback>
  </div>
  <div v-else>
    <b-form-input
      v-model="inputValue"
      :placeholder="controller.placeholder"
      :class="classname"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'SimpleTextInputConfiguration',
  props: {
    controller:{
      type:Object,
      required: true
    },
    sizeinput:{
      type: String,
      required:false,
      default: ''
    },
    eventonchange:{
      type:Boolean,
      required: false,
      default: false
    },
    classname:{
      type: String,
      required: false,
      default: ''
    }
  },
  computed: { 
    inputValue: {
      set (value) {
        this.controller.setValue(value)
        if(this.eventonchange){
          this.$emit('onChange')
        }
      },
      get () {
        return this.controller.value
      }
    },
   },
   methods: { 
    ...mapActions(['setContextOnHover']),
    onHover() {
      if(this.controller.contextHelp!==null){
        this.setContextOnHover(this.controller.contextHelp)
      }
    },
    onLeave(){
      if(this.controller.contextHelp!==null){
        this.setContextOnHover(null)
      }
    }
  }
}
</script>

<style scoped>
.label-input{
  margin: 0;
}
</style>